import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { getBotspec } from 'data/selectors';
import { isNotEmpty } from 'utils';
import { fetchGlobalVariables } from 'data/actions/globalVariables';
import SpecDropdownView from './SpecDropdownView';

const buildNodes = (key, prefix, nodes) => ({
  key,
  label: key.charAt(0).toUpperCase() + key.slice(1),
  nodes: Object.keys(nodes).reduce((accum, id) => {
    accum.push({ key: `${prefix}${id}`, label: id });
    return accum;
  }, []),
});

const SpecDropdown = ({ position, onChange, toggleDisplay }) => {
  const dispatch = useDispatch();
  const botspec = useSelector(getBotspec);
  const [globalVariables, setGlobalVariables] = useState({});

  useEffect(() => {
    dispatch(fetchGlobalVariables())
      .then((vars) => {
        setGlobalVariables(vars || {});
      })
      .catch(() => {
        setGlobalVariables({});
      });
  }, [dispatch]);

  const buildTreeData = () => {
    const specJson = botspec && botspec.spec_json ? botspec.spec_json : {};

    if (isNotEmpty(specJson)) {
      const { variables } = specJson;
      const treeData = [
        { ...buildNodes('user', 'user_', variables.user) },
        { ...buildNodes('chatbot', '_', variables.chatbot) },
        { ...buildNodes('session', '', variables.session) },
      ];

      // Agregar variables globales si existen
      if (Object.keys(globalVariables).length > 0) {
        treeData.push({ ...buildNodes('global', 'global_', globalVariables) });
      }

      return treeData;
    }

    return [];
  };

  return (
    <SpecDropdownView
      position={position}
      onChange={onChange}
      toggleDisplay={toggleDisplay}
      treeData={buildTreeData()}
    />
  );
};

SpecDropdown.propTypes = {
  position: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number,
  }),
  onChange: PropTypes.func,
  toggleDisplay: PropTypes.func,
};

SpecDropdown.defaultProps = {
  position: { top: 0, left: 0 },
  onChange: () => {},
  toggleDisplay: () => {},
};

export default SpecDropdown;
